module.exports = __webpack_public_path__ + "img/h2.7fd7c83a.png";